<template>
    <div class="compare-button-container full-width text-center">
        <button v-bind:disabled="loading" v-on:click="buttonClicked" aria-pressed="false" class="compare-button border py-2 px-4 text-center tiny-text cursor-pointer">
            <input name="checkbox" v-model="isChecked" v-bind:id="this.sku" type="checkbox" />{{ this.text }}
        </button>
    </div>

</template>

<script>
    export default {
        props: [
            'sku',
            'title',
            'slug',
            'image',
            'checked',
            'text'
        ],

        data() {
            return {
                selected: [],
                search: {},
                loading: false,
                isChecked: false,
            }
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {

                if (this.checked === 'true') {
                    this.isChecked = true;
                }

                const self = this;

                bus.$on('compare:loading', function() {
                    this.loading = true;
                }.bind(this));

                bus.$on('compare:loaded', function() {
                    if (window.CompareService.skuInCompare(self.sku) === true){
                        self.setActive();
                    } else {
                        self.setInactive();
                    }
                    this.loading = false;
                }.bind(this));

                bus.$on('compare:maxItemsReached', function(value) {
                    this.loading = value;
                }.bind(this));


            },

            /**
             * Add product to the session
             */
            addToSession() {
                let product = {
                    'Title': this.title,
                    'Sku': this.sku,
                    'Slug': this.slug,
                    'Image': this.image
                };

                if( window.CompareService.addProduct(product)){
                    window.CompareService.addToSession(this.sku);
                    this.setActive();
                }else{
                    alert("Er kunnen maximaal 10 producten worden vergeleken");
                }

            },

            /**
             * Remove product from the session
             */
            removeFromSession() {
                window.CompareService.removeProduct(this.sku);
                this.setInactive();
            },

            setActive(){
                this.isChecked = true;
            },

            setInactive(){
                this.isChecked = false;
            },

            /**
             * If button is clicked, determine if button was checked to begin with and make it the opposite
             */
            buttonClicked(){
                if(this.isChecked){
                    this.removeFromSession();
                } else {
                    this.addToSession();
                }
            }
        }
    }
</script>